<p class="rainbow-animated-text m-5 text-xl font-bold">APRIL FOOLS!</p>
